import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../../AppStateProvider';
import type { Contact } from '../../../domain/contact';
import type { CrmContactsPayload } from '../api';
import { contactsApi } from '../api';

import crmContactQueryKey from './crmContactQueryKey';

export const useCrmContactQuery = (): UseQueryResult<Contact | null> => {
  const { companyDomain, collectedContactInfo, isOpen } = useAppState();

  const isEnabled = () => {
    if (!isOpen) {
      return false;
    }

    return Boolean(collectedContactInfo?.name) && Boolean(collectedContactInfo?.companyName || companyDomain);
  };

  const fetchCrmContact = async ({ signal }: { signal?: AbortSignal }) => {
    const payload = [
      { Domain: companyDomain, FullName: collectedContactInfo?.name, CompanyName: collectedContactInfo?.companyName },
    ] as CrmContactsPayload[];

    const contacts = await contactsApi.getCrmContacts(payload, signal);

    return contacts?.[0] || null;
  };

  return useQuery({
    queryKey: crmContactQueryKey.fromState({
      Domain: companyDomain,
      FullName: collectedContactInfo?.name,
      CompanyName: collectedContactInfo?.companyName,
    }),
    queryFn: fetchCrmContact,
    enabled: isEnabled(),
  });
};
